import React, { useRef, useState } from "react";
import { useOutsideClickHandler } from "../../hooks";
import { deepCopy } from "../../utils";

const SPACEBAR = ' ';

function TagsField({ tags, selectedTags, onChange, disabled }) {

    const [inputValue, setInputValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const selectRef = useRef(null);
    const inputRef = useRef(null);

    useOutsideClickHandler(selectRef, () => handleOutsideClick());

    const selectTag = (name) => {
        const tagsCopy = deepCopy(selectedTags);
        tagsCopy.push({ name });
        onChange(tagsCopy);
    }

    const onDropdownClick = (name) => {
        const tagsCopy = deepCopy(selectedTags);
        const tag = tags.find(tag => tag.name === name);
        tagsCopy.push(tag);
        onChange(tagsCopy);
    }

    const unselectTag = (index) => {
        const tagsCopy = deepCopy(selectedTags);
        tagsCopy.splice(index, 1);
        onChange(tagsCopy);
    }

    const onInputChange = (value) => {
        setShowDropdown(true)
        if (value.includes(SPACEBAR) && value !== SPACEBAR) {
            if (!selectedTags.find(tag => tag.name === value.trim())) {
                selectTag(value.trim());
            }
            setInputValue('');
        } else {
            if (value !== SPACEBAR) {
                setInputValue(value);
            }
        }
    }

    const onRemoveClick = (index) => {
        unselectTag(index);
        setInputValue('');
    }

    const onSelectAreaClick = () => {
        setShowDropdown(!showDropdown);
        inputRef.current.focus();
    }

    const handleOutsideClick = () => {
        setShowDropdown(false);
        setInputValue('');
    }

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="device-tags">Tags</label>
                <span className={`select2 select2-container select2-container--bootstrap4 modal-v2-tags-select ${disabled ? 'select-disabled' : ''} ${showDropdown ? 'is-open' : ''}`}>
                    <span className="selection" ref={selectRef}>
                        <span className="select2-selection select2-selection--multiple"
                            onClick={disabled ? null : () => onSelectAreaClick()}>
                            <ul className="select2-selection__rendered">

                                {selectedTags.map((tag, index) =>
                                    <li key={index} className="select2-selection__choice">
                                        <span className="select2-selection__choice__remove"
                                            onClick={disabled ? null : () => onRemoveClick(index)}
                                        >×</span>
                                        {tag.name}
                                    </li>
                                )}

                                <li className="select2-search select2-search--inline">
                                    <input className="select2-search__field" type="search"
                                        id="device-tags"
                                        ref={inputRef}
                                        disabled={disabled}
                                        autoComplete="off" autoCorrect="off"
                                        autoCapitalize="none" spellCheck="false"
                                        placeholder={selectedTags.length ? "" : "Select tag"}
                                        aria-autocomplete="list" value={inputValue}
                                        onChange={disabled ? null : event => onInputChange(event.target.value)} />
                                </li>

                            </ul>
                        </span>
                        <span className="modal-v2-tags-select-chevron" aria-hidden="true" />
                        {showDropdown && <Dropdown selectedTags={selectedTags}
                            setInputValue={setInputValue}
                            setShowDropdown={setShowDropdown}
                            onClick={onDropdownClick}
                            options={tags.filter(tag => tag.name.toLowerCase().includes(inputValue.toLowerCase()))} />}
                    </span>
                </span>
            </div>
        </div>
    )
}

const Dropdown = ({ options, selectedTags, setInputValue, setShowDropdown, onClick }) => {

    const handleClick = (tagName, selected) => {
        if (!selected) {
            onClick(tagName);
            setInputValue('');
            setShowDropdown(false);
        }
    }

    return (
        <span className="select2-dropdown oct_left-zero">
            <span className="select2-results">
                <ul className="select2-results__options">
                    {(options && options.length > 0) ?
                        <>
                            {options.map((option, index) => {
                                if (selectedTags.find(tag => tag.name === option.name)) {
                                    return <li key={index} className={`select2-results__option ${option.selected ? 'selected' : ''}`}
                                        onClick={() => handleClick(option.name, true)} >{option.name}</li>
                                }
                                return <li key={index} className="select2-results__option"
                                    onClick={() => handleClick(option.name, false)}>{option.name}</li>
                            })}
                        </>
                        :
                        <li role="alert" aria-live="assertive"
                            className="select2-results__option select2-results__message">No results found</li>}
                </ul>
            </span>
        </span>
    )
}


export default TagsField;
